import { render } from "./ForumCategoryForm.vue?vue&type=template&id=0d7554d0&scoped=true"
import script from "./ForumCategoryForm.vue?vue&type=script&lang=js"
export * from "./ForumCategoryForm.vue?vue&type=script&lang=js"

import "./ForumCategoryForm.vue?vue&type=style&index=0&id=0d7554d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7554d0"]])

export default __exports__